import { createContext, useContext } from 'react';
import { FeatureToggle } from 'vrlcm-gui-types';

export const FeatureToggleContext = createContext<FeatureToggle>({
  inProductFeedback: false
});

export function useFeatureToggle() {
  const featureToggle = useContext(FeatureToggleContext);
  return featureToggle;
}
